var __WEBPACK_NAMESPACE_OBJECT__ = proj4;